import { Suspense } from 'react';
import { usePrefetchFeatureFlags } from '#api/org.queries.ts';
import { usePrefetchTagsCount, useSuspenseMaxTagsQuery } from '#api/tags.queries.ts';
import { ReorderIcon } from '#assets/ReactSvg.ts';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';
import { HeaderButtons } from '#components/patterns/header-buttons/HeaderButtons.tsx';
import { TableLayout } from '#components/patterns/layouts/table/TableLayout.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { EmptyTags } from '#screens/tags/empty/EmptyTags.tsx';
import { TagsList } from '../list/TagsList.tsx';

export function TagsPage() {
  const tags = useSuspenseMaxTagsQuery().data.data;

  {
    // prefetch for add tag page
    usePrefetchTagsCount();
    usePrefetchFeatureFlags();
  }

  if (tags.length === 0) {
    return <EmptyTags />;
  }

  return (
    <TableLayout
      header={
        <PageHeader title="Tags" preventTitleWrap={true}>
          <HeaderButtons
            additionalButtons={[
              {
                key: '1',
                element: (
                  <Tooltip
                    key="1"
                    content="Reorder"
                    placement="left"
                    flip="bottom"
                    render={<LinkButton size="small" to="reorder" variant="icon" />}
                  >
                    <span className="visually-hidden">Reorder tags</span>
                    <ReorderIcon aria-hidden={true} />
                  </Tooltip>
                ),
              },
            ]}
          />
        </PageHeader>
      }
    >
      <Suspense fallback={<LoadingSpinner />}>
        <TagsList />
      </Suspense>
    </TableLayout>
  );
}
